import { loadStripe as _loadStripe } from "@stripe/stripe-js";
import * as Sentry from "@sentry/react";

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const loadStripe = async (publishableKey, options) => {
  const { retryOptions, ...rest } = options || {};
  const { retries = 3, minTimeout = 1000, factor = 2 } = retryOptions || {};

  let lastError;
  for (let attempt = 0; attempt < retries; attempt++) {
    try {
      const stripe = await _loadStripe(publishableKey, rest);
      if (!stripe) {
        throw new Error("loadStripe promise resolved, but no Stripe object found");
      }
      return stripe;
    } catch (error) {
      lastError = error;
      Sentry.captureException(error, {
        extra: { attempt: attempt + 1 },
        tags: { section: "loadStripe" },
      });
      if (attempt < retries - 1) {
        const timeout = minTimeout * Math.pow(factor, attempt);
        await delay(timeout);
      }
    }
  }

  throw lastError;
};
